module.exports = __webpack_public_path__ + "img/shks.3b438f45.png";